/** Helpers that derive display data from the raw fixtures in `src/data/fixtures.js`. */

const parsePair = (value) => (value ? value.split('-').map(Number) : null);

/**
 * Hockey result: `score` holds regulation goals; a draw is decided by `shootout`.
 * Returns goals, shoot-out goals (or null), the winner and whether it went to a shoot-out.
 */
export const matchResult = ({ home, away, score, shootout }) => {
  const [homeGoals, awayGoals] = parsePair(score);
  const shootoutGoals = parsePair(shootout);
  const homeWon =
    homeGoals === awayGoals && shootoutGoals ? shootoutGoals[0] > shootoutGoals[1] : homeGoals > awayGoals;
  return {
    homeGoals,
    awayGoals,
    shootout: shootoutGoals ? { home: shootoutGoals[0], away: shootoutGoals[1] } : null,
    winner: homeWon ? home : away,
    loser: homeWon ? away : home,
    decidedByShootout: Boolean(shootoutGoals) && homeGoals === awayGoals,
  };
};

export const involves = (match, team) => match.home === team || match.away === team;

/** Groups matches by calendar day, preserving order. */
export const groupByDay = (matches) =>
  matches.reduce((groups, match) => {
    const last = groups[groups.length - 1];
    if (last && last.day === match.date) last.matches.push(match);
    else groups.push({ day: match.date, matches: [match] });
    return groups;
  }, []);
